const AVATAR_GROUP = 'compass-ui-v2-avatar-group';
export { AVATAR_GROUP };
